const TABS = [
    { id: "gerencial", label: "GERENCIAL" },
    { id: "por-agente", label: "POR AGENTE" },
    { id: "consolidado", label: "CONSOLIDADO" },
    { id: "descartados", label: "DESCARTADOS" },
    { id: "testadores", label: "TESTADORES" },
    { id: "recusaram-atendimento", label: "RECUSARAM ATENDIMENTO" }
];

export default TABS